module.exports = __webpack_public_path__ + "img/ihg-res.7bbc4143.jpg";